<div class="opt-verification-container">
  <p-dialog header="Two Factor Authentication" (onHide)="onModalHide()" (onShow)="onModalShow()" [modal]="isVisible" [(visible)]="isVisible"
    [breakpoints]="{ '1220px': '50vw','1024px': '80vw' ,'575px': '95vw' }" styleClass="border-round-3xl">
    <div class="flex flex-column gap-3">
      @if (pinForm) {
        <div class="flex flex-column gap-3">
          @if (heading && heading.length > 0) {
            <div class="w-full text-center">
              <h4 class="mb-0 text-sm md:text-lg font-light" [innerHTML]="heading">
              </h4>
            </div>
          }
          @if (showErrorMessage && errorMessage) {
            <div>
              <div class="flex p-error justify-content-center text-sm md:text-lg">{{errorMessage}}</div>
            </div>
          }
          <sp-form-wrapper [formGroup]="pinForm" (submit)="onValidate()">
            <div class="flex flex-column align-items-center">
              <div>
                <div class="mb-3">
                  <p-inputOtp [autofocus]="true" formControlName="pin" [tabindex]="1" [integerOnly]="true"
                  [length]="6" class="w-full mb-1 justify-content-between"></p-inputOtp>
                  <sp-control-error [parameters]="['Code']"
                  [control]="pinForm.controls['pin']"></sp-control-error>
                </div>
                <div class="flex justify-content-center mb-3">
                  <button label="VALIDATE" pButton pRipple type="submit" class="p-button-rounded"
                    [disabled]="!pinForm.valid" size="small">
                  </button>
                </div>
              </div>
            </div>
          </sp-form-wrapper>
        </div>
      }
    </div>
  </p-dialog>
</div>